import styled from '@emotion/styled';
import { imagePath } from 'presentations/assets';
import { mediaMax, spacing } from 'presentations/views/styles';
import { ReactNode } from 'react';

interface Props {
  children?: ReactNode;
  className?: string;
}

export default function Component(props: Props) {
  return (
    <Container className={props.className}>
      <Inner>{props.children}</Inner>
    </Container>
  );
}

const Container = styled.div`
  /* text-align: center; */
  /* padding: ${spacing(32)} 0 ${spacing(32)}; */
  /* z-index: 0; */

  ${mediaMax.tablet} {
    background-size: 1590px;
    /* padding: 40px 40px 80px; */
    background-size: 100%;
  }

  ${mediaMax.tablet} {
    /* padding: 24px 0 80px; */
  }

  ${mediaMax.smartphone} {
    /* padding: 40px 0 40px; */
  }
  background: url(${imagePath('pages/top/202306/bg-grid.png', {
    width: 2560,
    height: 2060,
    dpr: 2,
  })})
    no-repeat center top;
  background-size: 1280px auto;
`;
const Inner = styled.div`
  background: url(${imagePath('pages/top/202306/line-bg/bg-left.png', {
        width: 167,
        height: 541,
      })})
      no-repeat left 0px top 0px,
    url(${imagePath('pages/top/202306/line-bg/bg-right.png', {
        width: 315,
        height: 793,
      })})
      no-repeat right 0px top 0px,
    url(${imagePath('pages/top/202306/line-bg/bg-bottom.png', {
        width: 239,
        height: 122,
      })})
      no-repeat left 220px bottom 0px;
  ${mediaMax.tablet} {
    background: url(${imagePath('pages/top/202306/line-bg/bg-left.png', {
          width: 80,
          height: 270,
        })})
        no-repeat left 0px top 0px,
      url(${imagePath('pages/top/202306/line-bg/bg-right.png', {
          width: 157,
          height: 396,
        })})
        no-repeat right 0px top 0px,
      url(${imagePath('pages/top/202306/line-bg/bg-bottom.png', {
          width: 139,
          height: 61,
        })})
        no-repeat left 220px bottom 0px;
  }
  ${mediaMax.smartphone} {
    background: url(${imagePath('pages/top/202306/line-bg/bg-left.png', {
          width: 40,
          height: 135,
        })})
        no-repeat left 0px top 0px,
      url(${imagePath('pages/top/202306/line-bg/bg-right.png', {
          width: 153,
          height: 198,
        })})
        no-repeat right 0px top 0px,
      url(${imagePath('pages/top/202306/line-bg/bg-bottom.png', {
          width: 69,
          height: 30,
        })})
        no-repeat left 220px bottom 0px;
  }
`;
